import { render } from "./KnowledgeGraph_v2.vue?vue&type=template&id=4b78d2e6&scoped=true"
import script from "./KnowledgeGraph_v2.vue?vue&type=script&lang=js"
export * from "./KnowledgeGraph_v2.vue?vue&type=script&lang=js"

import "./KnowledgeGraph_v2.vue?vue&type=style&index=0&id=4b78d2e6&lang=scss&scoped=true"
import "./KnowledgeGraph_v2.vue?vue&type=style&index=1&id=4b78d2e6&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\lessonplay_shell\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b78d2e6"]])

export default __exports__